import { render, staticRenderFns } from "./navigation-panel.vue?vue&type=template&id=1179cff7&scoped=true"
import script from "./navigation-panel.vue?vue&type=script&lang=js"
export * from "./navigation-panel.vue?vue&type=script&lang=js"
import style0 from "./navigation-panel.vue?vue&type=style&index=0&id=1179cff7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1179cff7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1179cff7')) {
      api.createRecord('1179cff7', component.options)
    } else {
      api.reload('1179cff7', component.options)
    }
    module.hot.accept("./navigation-panel.vue?vue&type=template&id=1179cff7&scoped=true", function () {
      api.rerender('1179cff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/navigation-panel/navigation-panel.vue"
export default component.exports